import simbApi from ".";
import { GET_AUTHORIZED_USERS } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

export const getUsersBackend = async (access_token: string, accountId: number) => {
  try {
    const response = await simbApi.post(
      GET_AUTHORIZED_USERS,
      { accountId: accountId },
      {
        headers: { Authorization: `Bearer ${access_token}` },
      }
    );

    if (response?.data?.error) {
      throw new Error(response?.data?.error);
    }

    return response;
  } catch (error: any) {
    logger.error(error.message);
    throw error;
  }
};
